import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "extreme",
  "use": "extreme-usage",
  "viewBox": "0 0 120 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 120 128\" id=\"extreme\"><g fill=\"#6502a2\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M120 25.663V0H0v102.337l25.714-25.664v-51.01z\" /><path d=\"M102.857 76.673V51.01H51.111v25.663zM25.714 128H120v-25.663H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol